import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {openSampleEntry, openSampleSequence} from 'actions/OnboardingActions';
import * as analytics from 'analytics/Analytics';
import * as NewUserFlowActions from 'onboarding/new-user-flow/NewUserFlowActions';
import InfoSidePanel from 'onboarding/new-user-flow/signup-flow-v2/InfoSidePanel';
import SignupScreen from 'onboarding/new-user-flow/signup-flow-v2/SignupScreen';
import SignupScreenCard from 'onboarding/new-user-flow/signup-flow-v2/SignupScreenCard';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

interface ApplicationCardPanelProps {
  hoverOff: () => void;
  hoverNotebook: () => void;
  hoverMolBio: () => void;
}

function ApplicationCardPanel(props: ApplicationCardPanelProps): JSX.Element {
  const notebookBodyText = 'Plan multi-day experiments, centralize data, and share experimental results.';
  const molBioBodyText =
    'Annotate sequences, perform alignments, and design plasmids, primers, and CRISPR guides.';
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClickNotebook = () => {
    analytics.track('onboarding_page', 'clicked', {
      page: 'molbio_or_notebook',
      objectClicked: 'button',
      objectText: 'Notebook',
      eventLastModified: 'FY22_Q2b3',
    });
    NewUserFlowActions.hideScreen();
    openSampleEntry();
  };
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleClickMolBio = () => {
    analytics.track('onboarding_page', 'clicked', {
      page: 'molbio_or_notebook',
      objectClicked: 'button',
      objectText: 'Molecular Biology',
      eventLastModified: 'FY22_Q2b3',
    });
    NewUserFlowActions.hideScreen();
    openSampleSequence();
  };
  return (
    <div className={css(styles.buttonPanel)}>
      <SignupScreenCard
        titleText="Notebook"
        bodyText={notebookBodyText}
        imagePath="/static/img/new-user-flow/notebook.png"
        onClick={handleClickNotebook}
        buttonText="Show me an entry"
        hoverOn={props.hoverNotebook}
        hoverOff={props.hoverOff}
      />
      <SignupScreenCard
        titleText="Molecular Biology"
        bodyText={molBioBodyText}
        imagePath="/static/img/new-user-flow/molbio.png"
        onClick={handleClickMolBio}
        buttonText="Open a sequence"
        hoverOn={props.hoverMolBio}
        hoverOff={props.hoverOff}
      />
    </div>
  );
}

interface MolBioOrNotebookScreenProps {
  hoverOff: () => void;
  hoverNotebook: () => void;
  hoverMolBio: () => void;
}

export default function MolBioOrNotebookScreen(props: MolBioOrNotebookScreenProps): JSX.Element {
  const titleText = 'Choose what you want to see first';
  const bodyText =
    'Benchling offers a suite of capabilities for capturing, analyzing, and sharing your data.';
  return (
    <SignupScreen>
      <Row className={css(styles.row)}>
        <Col xs={4} sm={6}>
          <InfoSidePanel titleText={titleText} bodyText={bodyText} />
        </Col>
        <Col xs={8} sm={6} className={css(styles.cardColumn)}>
          <ApplicationCardPanel {...props} />
        </Col>
      </Row>
    </SignupScreen>
  );
}

const styles = StyleSheet.create({
  row: {
    marginLeft: '52px',
    marginRight: '52px',
    height: '100%',
  },
  cardColumn: {
    height: '100%',
  },
  buttonPanel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    height: '100%',
    padding: '20px 0',
  },
});
